export default __webpack_public_path__ + "static/media/php7.47d4f746.svg";